import {Link} from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import {WebContext} from '../webcontext';
import {useLocation} from 'react-router-dom';
import WebPlayer from './webplayer';
import moment from 'moment';

export default function Header() {
  const service = useContext(WebContext);
  //console.log(service.web);

  const [menu] = useState([
    {url: '/', name: 'home'},
    {url: '/chat', name: 'chat'},
    {url: '/listen', name: 'listen'},
    {url: '/about', name: 'about'},
    {url: '/schedule', name: 'schedule'},
    {url: '/previous', name: 'previous'},
    {url: '/ourdjs', name: 'our djs'},
    {url: '/joinus', name: 'join us'},
    {url: '/socials', name: 'socials'},
    {url: '/shop', name: 'shop'},
  ]);

  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const location = useLocation();
  useEffect(() => {}, [location]);

  let date = Math.floor(new Date().getTime()/1000);

  const [mobileMenu, setMobileMenu] = useState(false);

  switch(service.web?.service.template) {
    case 2:
      return (
        <header className="site-header" id="site-header">
          <div className="header-top">
            <a href="/" className="logo" data-nav="">
              <img src={service.web?.service.avatar} alt="logo" className="logo-img" onerror="this.style.display='none';this.nextElementSibling.style.display='block'" />
              <span className="logo-text" style={{display:'none'}}>4<span className="logo-accent">THE</span>MUSIC</span>
            </a>

            <nav className="main-nav">
              {menu.map((e, i) => {
                return (
                  <Link key={i} to={e.url} data-nav="" className={`nav-link ${location.pathname === e.url?'active':''}`}>{e.name}</Link>
                )
              })}
            </nav>

            <div className="header-actions">
              <Link to="/login" data-nav="" className="btn btn-sm">Login</Link>
              {service.web?.service.donation &&
                <a href={service.web.service.donation} target="_blank" data-nav="" className="btn btn-sm">Donate</a>
              }

              <button className="menu-toggle">
                <i className="fas fa-bars"></i>
              </button>
            </div>
          </div>

        
          <div className="player-bar" x-data="player()">
            <WebPlayer />
            
            <span style={{flex:1}}></span>
            
            <div className="player-marquee">
              <span className="player-marquee-label">Coming up:</span>
              <div className="player-marquee-scroll">
                <div className="player-marquee-content">
                  {service.web?.schedule.map((e, i) => {
                    return e.events.map((f, j) => {
                      let start = Math.floor(new Date(f.start)/1000);
                      if( start > date - 3600 )
                        return (
                          <span key={j} className="marquee-item">
                            <span className="marquee-time" data-uk-hour="16" data-uk-day="4">{moment(f.start).format("HH:mm")}</span>
                            <span className="marquee-dj">{f.djtitle?f.djtitle:f.title?f.title:f.username}</span>
                            {/*<span className="live-badge" style={{fontSize: '0.5rem', padding: '0.05rem 0.3rem'}}>LIVE</span>*/}
                            <span className="marquee-sep">|</span>
                          </span>
                        )
                      else return null;
                    })
                  })}
                </div>
              </div>
          </div>
         </div>
        </header>
      )
    case 1:
      return (
        <header className={`header-section header-onestyle cmn-breadcrumnd-header cmn-fixed py-lg-2 py-6 ${scrollPosition!==0&&'animated fadeInDown header-fixed'}`}>
          <div className="container">
            <div className="main-navbar">
              <nav className="navbar-custom">
                <div className="d-lg-flex flex-xl-nowrap flex-wrap align-items-center justify-content-lg-between">
                  <div className="d-flex align-items-center justify-content-between">
                    <Link to={'/'} className="brand-logo" onClick={()=>setMobileMenu(false)}>
                      <img className="w-100" src={service.web?.service.avatar} alt="logo" />
                    </Link>
                    <div className="d-flex align-items-center gap-xxl-5 gap-5">
                      <button className="navbar-toggle-btn d-block d-lg-none" type="button" onClick={()=>setMobileMenu(!mobileMenu)}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </button>
                    </div>
                  </div>
                  <div className="navbar-toggle-item" style={{display: mobileMenu ? 'block' : 'none'}}>
                    <ul className="custom-nav d-lg-flex d-grid gap-xxl-12 gap-xl-8 gap-lg-5 gap-md-2 gap-2 pt-lg-0 pt-5">
                      {menu.map((e, i) => {
                        return (
                          <li key={i} className="menu-item position-relative">
                            <Link to={e.url} className="position-relative  white-clr fw_500 cus-z1" onClick={()=>setMobileMenu(false)}>
                              {e.name}
                            </Link>
                          </li>
                        )
                      })}
                      {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').length > 0 &&
                        <li className="menu-item position-relative">
                          <button href="contact.html" className="fw_500">
                            Socials
                          </button>
                          <ul className="sub-menu px-lg-4 py-xxl-3 py-2">
                            {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').map((e, i) => {
                              return (
                                <li className="menu-link py-1">
                                  <a href={service.web?.service[e]} target="_blank" rel="noreferrer" className="fw_500 white-clr">{e.charAt(2).toUpperCase()+e.slice(3)}</a>
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                      }
                    </ul>
                  </div>
                  {service?.web?.service?.donation &&
                    <div className="d-lg-flex d-none d-grid justify-content-center ph-clickwrap align-items-center gap-xxl-3 gap-xl-2 gap-1">
                      <a href={service.web.service.donation} target="_blank" rel="noreferrer" className="d-flex align-items-center text-uppercase fw-500 py-2 pe-2 ps-xxl-7 ps-3 theme-bg gap-sm-4 gap-2 touch-btn">
                        Donate Us
                        <span className="icon d-center whitebg">
                          <i className="ph-fill ph-heart theme-clr"></i>
                        </span>
                      </a>
                    </div>
                  }
                </div>
              </nav>
            </div>
          </div>
        </header>
      )
    default:
      return (<></>)
  }
}
